import { render } from "./clients.vue?vue&type=template&id=9cb2c6ba&scoped=true"
import script from "./clients.vue?vue&type=script&lang=js"
export * from "./clients.vue?vue&type=script&lang=js"

import "./clients.vue?vue&type=style&index=0&id=9cb2c6ba&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/greenbelt_garbage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cb2c6ba"]])

export default __exports__